module.exports = __webpack_public_path__ + "static/media/ProximaNova-Light.ac51ad8a.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/ProximaNova-Light.otf
 ** module id = 873
 ** module chunks = 44
 **/